import type { ReactNode } from "react";
import type { SiteInfo } from "@/components/UI/SitesMap/types";
import { PortfolioMetricTile } from "@/views/Portfolio/shared";
import {
  formatDecimal,
  formatNumberWithGrouping,
} from "@/utils/numberFormatting";

type Props = { siteInfo: SiteInfo | null };

function MetricsShell({
  columns,
  children,
}: {
  columns: number;
  children: ReactNode;
}) {
  return (
    <div className="overflow-hidden rounded-[8px] border border-[#F0F2F4] bg-white shadow-[0_8px_24px_rgba(15,23,42,0.08)]">
      <div
        className="grid divide-x divide-[#F0F2F4] border-b border-[#F0F2F4]"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {children}
      </div>
    </div>
  );
}

export default function VisitsTab({ siteInfo }: Props) {
  const s = siteInfo;

  const openMvrItems = s?.open_mvr_action_items_count_derived ?? 0;
  const closedMvrItems = s?.closed_mvr_action_items_count_derived ?? 0;
  const longOpenMvrItems = s?.long_open_mvr_action_items_count_derived ?? 0;
  const daysOnSiteRequired = s?.days_on_site_required_count_derived ?? 0;
  const monthsOpen = s?.months_open_count_derived ?? 0;

  return (
    <div className="flex flex-col gap-4 p-4">
      <MetricsShell columns={4}>
        <PortfolioMetricTile
          label="OPEN MVR ITEMS"
          value={formatNumberWithGrouping(openMvrItems)}
        />
        <PortfolioMetricTile
          label="CLOSED MVR ITEMS"
          value={formatNumberWithGrouping(closedMvrItems)}
        />
        <PortfolioMetricTile
          label="LONG-OPEN MVR ITEMS"
          value={formatNumberWithGrouping(longOpenMvrItems)}
        />
        <PortfolioMetricTile
          label="DAYS ON SITE REQUIRED"
          value={formatNumberWithGrouping(daysOnSiteRequired)}
        />
      </MetricsShell>
      <MetricsShell columns={1}>
        <PortfolioMetricTile
          label="MONTHS SITE OPEN"
          value={formatDecimal(monthsOpen, 0)}
          suffix="mo"
        />
      </MetricsShell>
    </div>
  );
}
